import { gql } from '@apollo/client'
import { DISCOUNT_TYPE } from 'features/Coupons/components/DiscountType/constants'

import { sanitizePrice } from 'utils/math'

export const ACTIVATE_COUPON = gql`
  mutation ActivateCoupon($campaignId: ID!, $couponId: ID!) {
    activateCampaignCoupon(input: { id: $campaignId, coupon: { id: $couponId } })
  }
`

export const ACTIVATE_LOCAL_COUPON = gql`
  mutation ActivateLocalCoupon($id: ID!) {
    activateCoupon(id: $id) @client
  }
`

export const DEACTIVATE_LOCAL_COUPON = gql`
  mutation DeactivateLocalCoupon($id: ID!) {
    deactivateCoupon(id: $id) @client
  }
`

export const getCouponValue = ({ discountType, discountValue }: TSFixMe): TSFixMe => {
  return discountType === DISCOUNT_TYPE.PERCENTAGE
    ? parseFloat(discountValue)
    : sanitizePrice(discountValue * 100, true)
}

export const resolvers = {
  Mutation: {
    activateCoupon(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Coupon',
          id
        }),
        fragment: gql`
          fragment CouponIsActive on Coupon {
            isActive
          }
        `,
        data: {
          isActive: true,
          __typename: 'Coupon'
        }
      })

      return null
    },
    deactivateCoupon(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Coupon',
          id
        }),
        fragment: gql`
          fragment CouponIsActive on Coupon {
            isActive
          }
        `,
        data: {
          isActive: false,
          __typename: 'Coupon'
        }
      })

      return null
    }
  }
}
